var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React from 'react';
import { SvgIcon } from './svg-icon';
export var NavHamburgerIcon = function NavHamburgerIcon(props) {
  return React.createElement(SvgIcon, __assign({}, props, {
    viewBox: "0 0 36 36"
  }), React.createElement("rect", {
    width: "36",
    height: "6"
  }), React.createElement("rect", {
    y: "15",
    width: "36",
    height: "6"
  }), React.createElement("rect", {
    y: "30",
    width: "36",
    height: "6"
  }));
};